import UpdateRole from './Update';

export default UpdateRole;
